import { useMemo } from 'react';
import { COMBO_BOX_OPTIONS_3 } from '../combobox-popovers/all-filters-combobox-popover';
import CreatedDateFiltersComboBoxPopover from '../combobox-popovers/created-date-filters-combobox-popover';
import {
  type CreatedDateFilterChipProps,
  type CreatedDateFiltersState,
  LAST_UPDATED_DATE_FILTER_OPTIONS,
} from '../types';
import BaseDateFilterChip from './base-date-filter-chip';

const CreatedDateFilterChip = (props: CreatedDateFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  const selectedOption = useMemo(() => {
    return LAST_UPDATED_DATE_FILTER_OPTIONS.find(
      (option) => option.value === filtersState.selectedFilters,
    );
  }, [filtersState.selectedFilters]);

  const useBeforeAfterCopy = true;

  return (
    // TODO: fix the type
    <BaseDateFilterChip<CreatedDateFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={CreatedDateFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS_3.find((option) => option.value === 'created_date')
          ?.icon
      }
      filterName="Created date"
      filterQuantifier={{
        singular: selectedOption?.label || '',
        plural: selectedOption?.label || '',
      }}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      useBeforeAfterCopy={useBeforeAfterCopy}
    />
  );
};

export default CreatedDateFilterChip;
